import api from "./api";

export async function getVault() {
  const { data } = await api.get("/api/vault");
  return data;
}

export async function createDoc(payload) {
  // payload: { section_id, name, kind }
  const { data } = await api.post("/api/vault/docs", payload);
  return data;
}

export async function uploadDoc(docId, file, onProgress) {
  const fd = new FormData();
  fd.append("file", file);
  const { data } = await api.post(
    `/api/vault/docs/${docId}/upload`,
    fd,
    {
      headers: { "Content-Type": "multipart/form-data" },
      timeout: 180000,
      onUploadProgress: (e) => {
        if (e.total && typeof onProgress === "function") {
          onProgress(Math.min(100, Math.round((e.loaded / e.total) * 100)));
        }
      },
    },
  );
  return data;
}

export async function downloadDoc(docId) {
  const resp = await api.get(`/api/vault/docs/${docId}/download`, {
    responseType: "blob",
    timeout: 120000,
  });
  return resp; // caller handles save / preview
}

export async function updateDoc(docId, patch) {
  const { data } = await api.patch(`/api/vault/docs/${docId}`, patch);
  return data;
}

export async function deleteDoc(docId) {
  await api.delete(`/api/vault/docs/${docId}`);
  return true;
}

export async function draftWithAi(docId) {
  const { data } = await api.post(
    `/api/vault/docs/${docId}/draft-with-ai`,
    {},
    { timeout: 90000 },
  );
  return data;
}
